<template>
  <div>
    <v-col cols="12" v-if="informText != ''">
      <v-alert type="error">{{ informText }}</v-alert>
    </v-col>

    <v-col cols="12">
      <v-row>
        <v-col cols="5">
          <v-select
            dense
            outlined
            :items="platformList"
            label="Select Platform"
            v-model="platformSelected"
          ></v-select>
        </v-col>

        <v-col cols="5">
          <v-select
            dense
            outlined
            :items="amzList"
            :item-text="(obj) => obj.code"
            :item-value="(obj) => obj.code"
            label="Select AMZ Store"
            multiple
            v-model="storesSelected"
            v-if="platformSelected == 'Amazon'"
          ></v-select>

          <v-select
            dense
            outlined
            :items="spfList"
            :item-text="(obj) => obj.code"
            :item-value="(obj) => obj.code"
            label="Select SPF Store"
            multiple
            v-model="storesSelected"
            v-if="platformSelected == 'Shopify'"
          ></v-select>
        </v-col>

        <v-col cols="2">
          <v-btn @click="loadData" color="success" v-if="platformSelected != ''"
            >View Report</v-btn
          >
        </v-col>
      </v-row>

      <v-data-table :items="reportData" :headers="headers" :search="search">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-row>
              <v-col cols="2">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-toolbar>
          <hr />
        </template>

        <template v-slot:item.base_cost="{ item }">
          $ {{ item.base_cost }}
        </template>
        <template v-slot:item.complains="{ item }">
          <div v-if="item.summaryComplains.total > 0">
            Total: {{ item.summaryComplains.total }} ({{
              item.summaryComplains.percent.toFixed(2)
            }}%)
          </div>
          <div v-if="item.summaryComplains.damage > 0">
            {{ item.summaryComplains.damage }}x damage, faults, and incorrect
          </div>
          <div v-if="item.summaryComplains.lost > 0">
            {{ item.summaryComplains.lost }}x lost or delayed delivery
          </div>
          <div v-if="item.summaryComplains.poor > 0">
            {{ item.summaryComplains.poor }}x poor quality
          </div>
        </template>
        <template v-slot:item.additional_item_cost="{ item }">
          $ {{ item.additional_item_cost }}
        </template>
        <template v-slot:item.avg_production_time="{ item }">
          <template v-if="item.avg_production_time">
            {{ item.avg_production_time }} day(s)
          </template>
        </template>
        <template v-slot:item.avg_shipping_time="{ item }">
          <template v-if="item.avg_shipping_time">
            {{ item.avg_shipping_time }} day(s)
          </template>
        </template>
      </v-data-table>
    </v-col>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "VendorPerformance",

  props: {},

  data: () => ({
    reportData: [],
    platformList: ["All", "Shopify", "Amazon"],
    amzList: [],
    spfList: [],

    headers: [
      { text: "Product", value: "product" },
      { text: "Variant", value: "variant" },
      { text: "Vendor", value: "vendor" },
      { text: "Sales", value: "sales" },
      { text: "Complains", value: "complains" },
      { text: "Basecost (US country)", value: "base_cost" },
      { text: "Additional Item", value: "additional_item_cost" },
      {
        text: "Avg.Production time last 30 days (Paid to Shipped)",
        value: "avg_production_time",
      },
      {
        text: "Avg.Shipping time last 30 days (Shipped to Delivered)",
        value: "avg_shipping_time",
      },
    ],
    search: null,

    platformSelected: "",
    storesSelected: [],
    informText: "",
  }),

  methods: {
    async getAllStore() {
      this.informText = "";
      var currentSession = await this.$root.$refs.App.currentSession(
        "fulfillment-getAllStore"
      );

      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "sites?platform=Amazon", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("response Amz: ", response);
            if (response.data.error_message == "")
              this.amzList = response.data.data;
            else this.informText = response.data.error_message;
          });

        await axios
          .get(window.domain + "sites?platform=Shopify", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("response Spf: ", response);
            if (response.data.error_message == "")
              this.spfList = response.data.data;
            else this.informText = response.data.error_message;
          });
      }
    },

    async loadData() {
      this.informText = "";
      this.reportData = [];
      var queryParams = {
        report_type: "fulfillment",
      };

      if (this.platformSelected == "All") {
        queryParams["platform"] = this.platformSelected;
      } else {
        queryParams["platform"] = this.platformSelected;
        queryParams["storeCodes"] = this.storesSelected;
      }

      var currentSession = await this.$root.$refs.App.currentSession(
        "fulfillment-loadData"
      );

      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "reports/fulfillment", {
            headers: { Authorization: currentSession.accessToken },
            params: queryParams,
          })
          .then((response) => {
            console.log("response: ", response);
            if (response.data.error_message == "") {
              this.reportData = response.data.data;
              this.convertData();
            } else {
              this.informText = response.data.error_message;
            }
          })
          .catch((err) => console.log("Error: ", err));
      }
    },

    convertData() {
      for (var a of this.reportData) {
        a["summaryComplains"] = {
          ["total"]: 0,
          ["percent"]: 0,
          ["damage"]: 0,
          ["lost"]: 0,
          ["poor"]: 0,
        };

        for (var b of a.complains) {
          console.log("b: ", b);
          if (b.complain_type == "damage, faults, and incorrect") {
            a["summaryComplains"]["damage"] += 1;
          }
          if (b.complain_type == "lost or delayed delivery") {
            a["summaryComplains"]["lost"] += 1;
          }
          if (b.complain_type == "poor quality") {
            a["summaryComplains"]["poor"] += 1;
          }
        }

        a["summaryComplains"]["total"] =
          a["summaryComplains"]["damage"] +
          a["summaryComplains"]["lost"] +
          a["summaryComplains"]["poor"];
        a["summaryComplains"]["percent"] =
          (a["summaryComplains"]["total"] / a.sales) * 100;
      }

      console.log("reportData: ", this.reportData);
    },
  },

  async mounted() {
    await this.getAllStore();
  },
};
</script>

<style lang="scss" scoped>
</style>